<script lang="ts">
    import { getDashboardCtx } from "../state/dashboard.svelte";
    import { translate } from "@/utils/format";
    import { goTo } from "@/utils/router";
    import { Dialog } from "@/components";
    let { onHelp, onProfile }: { onHelp: () => void; onProfile: () => void } = $props();

    const store = getDashboardCtx();
    let showLogoutConfirm = $state(false);
</script>

<div class="referralsTop">
    <div class="referrals__brand">
        <img
            src="/assets/img/logos/logo_black.png"
            alt="Caloo"
            class="referrals__logo"
        />
        <h3 class="referrals__title">
            {translate("PARTNER_DASHBOARD_TITLE", "Panel de Partner")}
        </h3>
    </div>
    <div class="referrals__header">
        <button
            type="button"
            class="referrals__help"
            onclick={onHelp}
            aria-label={translate("LANG_HELP", "Ayuda")}
        >
            <i class="fal fa-question-circle"></i>
        </button>
        <div
            class="referralsProfile"
            role="group"
            aria-label={translate("PARTNER_PROFILE", "Mi perfil")}
        >
            <button
                type="button"
                class="referralsProfile__main"
                onclick={onProfile}
                aria-label={translate("PARTNER_PROFILE", "Mi perfil")}
            >
                <img
                    src={store.user?.image ||
                        store.user?.logo ||
                        "/assets/img/defaultAvatar.png"}
                    alt={translate("PARTNER_PROFILE", "Mi perfil")}
                />
                <span>
                    {store.user?.name ||
                        translate("PARTNER_PROFILE", "Mi perfil")}
                </span>
            </button>
            <button
                type="button"
                class="referralsProfile__logout"
                onclick={(e) => {
                    e.stopPropagation();
                    showLogoutConfirm = true;
                }}
                aria-label={translate("LOGOUT", "Cerrar sesión")}
                title={translate("LOGOUT", "Cerrar sesión")}
            >
                <i class="fal fa-sign-out"></i>
            </button>
        </div>
    </div>
</div>

<Dialog
    isOpen={showLogoutConfirm}
    message={translate(
        "LOGOUT_CONFIRM",
        "¿Seguro que quieres cerrar sesión?",
    )}
    labelOk={translate("LOGOUT", "Cerrar sesión")}
    labelCancel={translate("CANCEL", "Cancelar")}
    onOk={() => {
        showLogoutConfirm = false;
        goTo("/logout");
    }}
    onCancel={() => (showLogoutConfirm = false)}
/>
